import type { PostType } from '../types/api';

export type ComposeKind = Extract<PostType, 'update' | 'offer' | 'event' | 'notice'>;

const KINDS: Array<{ id: ComposeKind; label: string }> = [
    { id: 'update', label: 'Update' },
    { id: 'offer',  label: 'Offer'  },
    { id: 'event',  label: 'Event'  },
    { id: 'notice', label: 'Notice' },
];

const HINTS: Record<ComposeKind, string> = {
    update: 'A short note to your suburb. Renders as a plain post.',
    offer:  'A deal, discount, or freebie. Price shows as a callout; expires when the "valid until" time passes.',
    event:  'Something happening at a set time. Must have a start; end is optional. Also appears on Diary.',
    notice: 'A heads-up or civic notice. Highlighted with a red rule so it stands out.',
};

interface Props {
    value:    ComposeKind;
    onChange: (k: ComposeKind) => void;
}

export function KindTabs({ value, onChange }: Props) {
    return (
        <div className="compose-field">
            <span>Kind</span>
            <div className="kind-tabs" role="tablist">
                {KINDS.map(k => (
                    <button
                        key={k.id} type="button" role="tab"
                        aria-selected={value === k.id}
                        className={'kind-tab' + (value === k.id ? ' is-active' : '')}
                        onClick={() => onChange(k.id)}
                    >
                        {k.label}
                    </button>
                ))}
            </div>
            <em className="compose-hint">{HINTS[value]}</em>
        </div>
    );
}
